import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LsqDataSource } from '@lsq-frontend/angular-shared/api-service';
import { FeatureFlags } from '@lsq-frontend/fasttrack-shared/app-constants';
import {
    atlas,
    REPORTS_AVAILABLE_FUNDS_SUMMARY,
    REQUEST_FUNDS
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { GetAccountSnapshotResponse } from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { forLifeOf, LifecycleAware, Styling, TourHelperService } from '@lsq-frontend/common-ui';
import {
    ClaimService,
    FeatureFlagService,
    getRouterLinkById,
    Icons,
    ResponsiveService
} from '@lsq-frontend/common-ui';
import { PopoverPlacement } from 'ngx-smart-popover';
import { combineLatest } from 'rxjs';
import { delay, filter, first, map } from 'rxjs/operators';
import { TourAnalyticsNames, TourIds, TourSteps } from '../../../constants/tours.constants';

@LifecycleAware()
@Component({
    selector: 'request-funds',
    templateUrl: './request-funds.component.html',
    styleUrls: ['./request-funds.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RequestFundsComponent implements OnInit {
    public isMobile = false;
    public claim = DashboardClaim;
    public placement = PopoverPlacement;
    public icons = Icons;
    @Input() public accountSnapshotDataSource: LsqDataSource<GetAccountSnapshotResponse>;

    constructor(
        private _featureFlagsService: FeatureFlagService,
        private _claimService: ClaimService,
        private _responsiveService: ResponsiveService,
        private _router: Router,
        private _tourHelperService: TourHelperService
    ) {}

    public ngOnInit(): void {
        // After both services return and we get the feature flag
        combineLatest(
            this._featureFlagsService.isOn(FeatureFlags.GuidedTour),
            this._responsiveService.smBelow,
            this._claimService.isOn(DashboardClaim.ViewReports),
            this._claimService.isOn(DashboardClaim.ViewRequestFunds)
        )
            .pipe(
                filter(([featureFlag, isMobile]) => featureFlag && !isMobile),
                first(),
                map(([_featureFlag, _isMobile, canViewReports, canViewRequestFunds]) => {
                    const tourSteps = TourSteps.createDashboardTourSteps(
                        canViewReports,
                        canViewRequestFunds
                    );
                    return this._tourHelperService.attachEndEvents(
                        {
                            tourId: TourIds.DashboardIntro,
                            minimumScreenSize: Styling.mdStart,
                            steps: tourSteps
                        },
                        TourAnalyticsNames.DashboardIntro
                    );
                }),
                delay(0),
                forLifeOf(this)
            )
            .subscribe((dashboardTour) => this._tourHelperService.startTour(dashboardTour));

        this._responsiveService.smBelow.pipe(forLifeOf(this)).subscribe((isMobile) => {
            this.isMobile = isMobile;
        });
    }

    public ngOnDestroy(): void {}

    public goToRequestFunds(): void {
        this._router.navigate(getRouterLinkById(atlas, REQUEST_FUNDS));
    }
    public goToViewAvailableFunds(): void {
        this._router.navigate(getRouterLinkById(atlas, REPORTS_AVAILABLE_FUNDS_SUMMARY));
    }
}
